export default [
  {
    path: '/:catchOldUrl',
    name: 'catchOldUrl',
    redirect: to => {
      return {
        name: 'SingleSpecies',
        params: { nameUrl: to.params.catchOldUrl }
      }
    }
  },
  {
    path: '*',
    name: '404',
    component: () => import(/* webpackChunkName: "404" */ '../views/404.vue')
  }
]
